<template>
  <div class="common-header">
    <span class="header_title">{{ title }}</span>
    <span class="more" v-if="isMore" @click="checkMore">
      <span>更多数据</span>
      <img src="./img/more.png" />
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String
      },
      isMore: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      checkMore() {
        this.$emit('checkMore')
      }
    }
  }
</script>

<style lang="less" scoped>
  .common-header {
    position: absolute;
    right: 0.34rem;
    margin-top: 1.4vh;
    width: 5.82rem;
    height: 5.19vh;
    background: url('./img/common_header.png') no-repeat;
    background-size: 100% 100%;

    .header_title {
      position: absolute;
      top: 0.93vh;
      left: 0.73rem;
      font-family: AdobeHeitiStd-Regular;
      font-size: 1.67vh;
      line-height: 1;
      color: #fff;
    }

    .more {
      position: absolute;
      top: 2.13vh;
      right: 0.07rem;
      display: inline-flex;
      align-items: center;
      font-family: AdobeHeitiStd-Regular;
      font-size: 1.3vh;
      line-height: 1;
      color: #00f0ff;
      cursor: pointer;

      img {
        margin-left: 0.1rem;
        width: 0.14rem;
        height: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spacerBar/commonHeader.vue